export enum PageType {
    REGULAR = 'REGULAR',
    LIST = 'LIST',
}
